<template>
  <div>
    <div class="bgc">
      <HeadNav />
      <div class="menuTitle">
        <div class="menuTitleText">噢哦，出错了！</div>
      </div>
    </div>
    <div class="wrapper">
      <div class="minAside">
      </div>
      <div class="middleBox">
        <div class="err-box" >
          <img width="100%" height="100%" src="https://t1.chei.com.cn/common/error/images/yz-error-icon.png" alt="">
          <h2>出错了</h2>
          <p>404 Not Found (没有找到访问的页面)</p>
        </div>
        <div class="bottomBox">
        </div>
      </div>
      <div class="rightBox">
      </div>
    </div>
    <pageFooter />
  </div>
</template>

<script>
import pageFooter from '@/components/pageFooter.vue'
import HeadNav from '@/components/HeadNav.vue'

export default {
  components: {
    HeadNav,
    pageFooter
  },
  data ()
  {
    return {}
  },
  created ()
  {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  background-color: #ffffff;
}

.bgc {
  height: 320px;
  position: relative;
  background-image: url('@/assets/images/bgc.png');
  background-size: 100%;
  background-position: center;
}

.menuTitle {
  position: absolute;
  bottom: 0;
  left: 300px;
  width: 216px;
  height: 80px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background: url('@/assets/images/menu.png');
}

.menuTitleText {
  width: 140px;
  height: 33px;
  font-size: 20px;
  margin-top: 24px;
  margin-left: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 33px;
}

.minAside {
  width: 216px;
  position: relative;
  left: 8px;
}

::v-deep .el-menu-vertical-demo {
  border-right: none;
  background: #f7f8fa;
  border-radius: 0 0 16px 16px;
}

::v-deep .el-submenu__title * {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1d2129;
  line-height: 22px;
}

::v-deep .el-submenu .el-menu-item {
  height: 56px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 56px;

  &:hover {
    color: #f53f3f;
    background-color: #ffece8;
  }
}

::v-deep.el-menu-item-group__title {
  padding: 0;
}

.middleBox {
  width: 744px;
  margin-left: 24px;
  background: #ffffff;
  padding-top: 26px;
  font-size: 24px;
}

.topMenu {
  margin-top: 40px;
}

.el-menu-demo {
  background: #ffffff;
  border: none;
}

::v-deep.el-menu--horizontal > .el-menu-item.is-active {
  color: #f53f3f;
  border-bottom: 3px solid #f53f3f;
  border-radius: 2px;
}

::v-deep .el-menu--horizontal > .el-menu-item {
  height: 25px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1d2129;
  line-height: 20px;
}

.bottomBox {
  padding: 0 24px 32px 24px;
  height: 96%;
  iframe {
    width: 100%;
    height: 100%;
  }
}

.contentBox {
  display: flex;
  justify-content: space-between;
  height: 64px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 64px;

  &:hover {
    color: #f53f3f;
  }
}

.time {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #86909c;
}

::v-deep .el-pager li.active {
  color: #f53f3f;
}

::v-deep .el-pager li:hover {
  color: #f53f3f;
}

//todo
::v-deep .el-select-dropdown__item.selected {
  color: #f53f3f !important;
}

::v-deep .el-pagination button:hover {
  color: #f53f3f !important;
}

::v-deep .el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #f53f3f;
}

::v-deep .el-menu-vertical-demo .el-submenu__title:hover {
  background-color: #ffece8 !important;
}

.rightBox {
  margin-top: 40px;
}

::v-deep .el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: #f53f3f !important;
}

::v-deep .el-range-editor.is-active:hover {
  border-color: #f53f3f !important;
}

::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #f53f3f !important;
}

.titleBox {
  // width: 72px;
  height: 25px;
  margin-bottom: 16px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1d2129;
  line-height: 25px;
}

.cardBox {
  //width: 312px;
  padding: 20px 24px;
  background: #f7f8fa;
  border-radius: 16px;
  margin-bottom: 16px;
}

.cardTitle {
  padding: 3px 5px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  border-radius: 4px;
  border: 1px solid #f53f3f;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #f53f3f;
  margin-bottom: 11px;
}

.cardItem {
  margin-top: 5px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
}

.textModel {
  width: 312px;
  height: 251px;
  background: #f7f8fa;
  border-radius: 16px;
  margin-top: 40px;
  padding: 24px 16px;
}

.modelTitle {
  // width: 72px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1d2129;
  line-height: 25px;
}

.modelContent {
  display: flex;
  align-items: center;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 20px;
  margin-top: 20px;
}

.modelLeft {
  margin-right: 16px;
}

.modelItem {
  border-radius: 4px;
  color: #f53f3f;
  margin-right: 8px;
  padding: 3px 5px;
  text-align: center;
  border: 1px solid #f53f3f;
}

.allButton {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #86909c;
  text-align: center;
  padding-top: 24px;
}

.imgTitle {
  height: 25px;
  margin-bottom: 16px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1d2129;
  line-height: 25px;
}

.imgModel {
  width: 312px;
  margin-top: 40px;
  padding: 16px 0;
}

.imgContent {
  display: flex;
  flex-wrap: wrap;
}

.imgItem {
  width: 144px;
  margin-right: 10px;
}

.imgStyle {
  border-radius: 8px;
  height: 90px;
}

.imgText {
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 20px;
  margin-top: 8px;
  margin-bottom: 24px;
}

.textBox {
  width: 312px;
  height: 350px;
  background: #f7f8fa;
  border-radius: 8px;
  margin-bottom: 80px;
  padding: 24px 16px;
}

.infoText {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
}

.radioColor {
  width: 4px;
  height: 4px;
  background: #f53f3f;
  margin-top: 8px;
  margin-right: 8px;
}

.infoContent {
  width: 256px;
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d2129;
  line-height: 20px;
}

::v-deep .el-menu-item:focus,
.el-menu-item:hover {
  background-color: #ffece8;
}

::v-deep .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  color: #ffffff;
}
::v-deep .el-breadcrumb__inner {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a9aeb8;
  line-height: 20px;
  cursor: pointer;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111a34;
  line-height: 20px;
  cursor: pointer;
}
.itemTitle {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1d2129;
  line-height: 33px;
  margin-bottom: 40px;
}
.err-box {
  width: 426px;
  margin: 100px auto;
  text-align: center;

 h2 {
   margin: 24px 0 6px;
   line-height: 32px;
   font-size: 24px;
   color: #333;
   font-weight: 700;
 }
  p {
    line-height: 22px;
    margin-bottom: 40px;
    font-size: 14px;
    color: #999;
  }

}

</style>

